<template>
  <div
    class="BookingDetails"
    :class="[loading == true ? 'loadingActive' : 'loadingOn']"
  >
    <div>
      <van-skeleton title :row="3" title-width="80" :loading="loading">
        <p class="BookingDetails-title">预定须知</p>
        <div class="BookingDetails-borde">
          <div class="BookingInstructions-padd">
            <div
              v-for="(item, index) in bookNotice"
              :key="index"
              class="BookingDetails-par"
            >
              <p class="BookingDetails-title-par">{{ item.key }}</p>
              <p
                class="BookingDetails-content"
                style="padding-left: 0px"
                v-html="item.value"
              ></p>
            </div>
          </div>
        </div>
        <p
          v-if="bookNotice == '' || bookNotice == null || bookNotice == []"
          class="BookingDetails-information"
        >
          <span> 暂无信息 </span>
        </p>
      </van-skeleton>
      <van-skeleton title :row="3" title-width="80" :loading="loading">
        <p class="BookingDetails-title">景区介绍</p>

        <p
          v-html="scenicDescription"
          class="BookingDetails-content"
          style="padding-top: 15px"
          v-if="scenicDescription != ''"
        ></p>
        <p
          v-if="
            scenicDescription == '' ||
            scenicDescription == null ||
            scenicDescription == []
          "
          class="BookingDetails-information"
        >
          <span> 暂无信息 </span>
        </p>
      </van-skeleton>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bookNotice: [],
      scenicDescription: "",
      loading: true,
    };
  },
  created() {
    this.TicketDetails();
  },
  methods: {
    TicketDetails() {
      this.$api
        .post("third-tickets/member/scenic/detail", {
          short_name: "PanHe",
          scenic_id: this.$route.query.scenic_id,
          is_index:true
        })
        .then((res) => {
          //console.log(res)
          this.bookNotice = res.bookNotice; //预定须知
          this.scenicDescription = res.scenicDescription; //景区介绍
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.loadingActive {
  background: #fff;
}
.loadingOn {
  background: #f3f8fb;
}
.BookingDetails {
  padding: 15px;
  .van-skeleton {
    margin-top: 30px;
    padding-bottom: 10px;
    .van-skeleton__title {
      width: 90px;
       height: 25px;
      border-radius: 20px;
    }
    .van-skeleton__content {
      border-radius: 20px;
    }
    .van-skeleton__row {
      //  height: 50px;
      // margin: 17px 0px;
      border-radius: 20px;
    }
  }
  .BookingDetails-information {
    font-size: 13px;
    color: #666;
    width: 100%;
    background: #fff;
    padding: 20px 0px;
    border-radius: 6px;
    span {
      margin-left: 10px;
    }
  }
  .BookingDetails-borde {
    border-radius: 6px;
    background: #fff;
    .BookingDetails-par:last-of-type {
      border-bottom: none;
    }
    .BookingInstructions-padd {
      background: #fff;
      border-radius: 6px;
    }
    .BookingDetails-par {
      width: 90%;
      margin: 0px 5%;
      padding: 5px 0px;
      background: #fff !important;
      border-bottom: 1px solid #efefef;

      .BookingDetails-title-par {
        font-size: 13px;
        font-weight: bold;
        margin-top: 10px;
      }
    }
  }

  .BookingDetails-title {
    color: #333;
    font-weight: bold;
    margin-top: 25px;
    margin-bottom: 15px;
  }
}
.BookingDetails-content {
  font-size: 13px;
  color: #666;
  line-height: 20px;
  background: #fff;
  padding: 10px;
  border-radius: 6px;
  /deep/ img {
    width: 100%;
    margin: 10px 0px;
  }
}
</style>
